export const well_known_cities = {
  "R71525": 2,
  "R65606": 2,
  "R175905": 2,
  "R271110": 2,
  "R41485": 2,
  "R347950": 2,
  "R62422": 2,
  "R435514": 2,
  "R44741": 2,
  "R109166": 2,
  "R58274": 2,
  "R44915": 2,
  "R42602": 2,
  "R111968": 2,
  "R62428": 2,
  "R1244004": 2,
  "R207359": 2,
  "R1128379": 2,
  "R5326784": 2,
  "R5400890": 2,
  "R122604": 2,
  "R5396194": 2,
  "N1882099475": 2,
  "R170117": 2,
  "R2315704": 2,
  "R36989": 2,
  "N13707878": 2,
  "R1216769": 2,
  "N441183": 2,
  "R1109531": 2,
  "R1920901": 2,
  "R62400": 2,
  "R1682248": 2,
  "R253832": 2,
  "R324211": 2,
  "R42527": 2,
  "R188022": 2,
  "R1543125": 2,
  "N25929985": 2,
  "R92277": 2,
  "R237385": 2,
  "R40767": 2,
  "R119557": 2,
  "R170100": 2,
  "R62578": 2,
  "R2220322": 2,
  "R449696": 2,
  "R1411339": 2,
  "N31248510": 2,
  "R336075": 2,
  "R6571629": 2,
  "R562654": 2,
  "R62782": 2,
  "R1685488": 2,
  "R1702499": 2,
  "R86538": 2,
  "R1634158": 2,
  "R3372453": 2,
  "R34914": 2,
  "R1852574": 2,
  "R17140517": 2,
  "R342563": 2,
  "R131885": 2,
  "R2688911": 2,
  "R146656": 2,
  "R111257": 2,
  "R913110": 2,
  "R133345": 2,
  "R406091": 2,
  "R197472": 2,
  "R2555133": 2,
  "R1216849": 2,
  "R76469": 2,
  "R17611454": 2,
  "R44830": 2,
  "R407489": 2,
  "N25248662": 2,
  "R340746": 2,
  "R113314": 2,
  "R394037": 2,
  "R344953": 2,
  "R1411101": 2,
  "R120965": 2,
  "R358674": 2,
  "R43172": 2,
  "R357794": 2,
  "N11127374": 2,
  "R59518": 2,
  "R421007": 2,
  "R2164745": 2,
  "R71033": 2,
  "R2388057": 2,
  "R2297418": 2,
  "R1675898": 2,
  "R5750005": 2,
  "N428039517": 2,
  "N778910398": 2,
  "R2939672": 2,
  "R186579": 2,
  "R11153757": 2,
  "R253556": 1,
  "R62539": 1,
  "R117955": 1,
  "R226224": 1,
  "R344685": 1,
  "R198770": 1,
  "R162378": 1,
  "R13048688": 1,
  "R5342409": 1,
  "R2728438": 1,
  "R134591": 1,
  "R44875": 1,
  "R192737": 1,
  "R172987": 1,
  "R295355": 1,
  "R4246124": 1,
  "R136712": 1,
  "N1326762432": 1,
  "R177415": 1,
  "R2793104": 1,
  "R2580605": 1,
  "R5466227": 1,
  "R191645": 1,
  "R188553": 1,
  "R13226684": 1,
  "R18438530": 1,
  "R2799538": 1,
  "R175031": 1,
  "R4835169": 1,
  "R112143": 1,
  "R170486": 1,
  "R62780": 1,
  "R897671": 1,
  "R42398": 1,
  "R377733": 1,
  "R4479763": 1,
  "R7510580": 1,
  "R112224": 1,
  "R1682378": 1,
  "R18271854": 1,
  "R4283101": 1,
  "R105270": 1,
  "R182130": 1,
  "R1180533": 1,
  "R91734": 1,
  "R1683619": 1,
  "R194119": 1,
  "R1682891": 1,
  "R2319206": 1,
  "R43992": 1,
  "R119231": 1,
  "R1973756": 1,
  "R46085": 1,
  "R119867": 1,
  "R183453": 1,
  "R419203": 1,
  "R110844": 1,
  "R1529146": 1,
  "R30295": 1,
  "N115664268": 1,
  "R1293250": 1,
  "N738885245": 1,
  "R1224652": 1,
  "R197239": 1,
  "R3661510": 1,
  "R10663667": 1,
  "N20913294": 1,
  "W1219767831": 1,
  "R191210": 1,
  "R1903516": 1,
  "R3864712": 1,
  "R6232940": 1,
  "R2697338": 1,
  "N57554537": 1,
  "R182706": 1,
  "R3353288": 1,
  "R1553098": 1,
  "R58404": 1,
  "R5746665": 1,
  "R2174951": 1,
  "R119008": 1,
  "R4136816": 1,
  "R171262": 1,
  "R342999": 1,
  "R39513": 1,
  "R251075": 1,
  "R339549": 1,
  "R1804307": 1,
  "R343207": 1,
  "R253985": 1,
  "R1481934": 1,
  "R112100": 1,
  "R18452118": 1,
  "R35738": 1,
  "R2763541": 1,
  "R421866": 1,
  "R179180": 1,
  "R45681": 1,
  "N428039507": 1,
  "R1685018": 1,
  "R112336": 1,
  "R2221062": 1,
  "N29438069": 1,
  "R179052": 1,
  "N292806332": 1,
  "N53200527": 1,
  "R1382494": 1,
  "R298285": 1,
  "R7789828": 1,
  "R1996871": 1,
  "R3227127": 1,
  "R118362": 1,
  "R1381350": 1,
  "R132500": 1,
  "R27332": 1,
  "R5404220": 1,
  "R451516": 1,
  "R193842": 1,
  "R1390623": 1,
  "R286380": 1,
  "R39230": 1,
  "N4289361265": 1,
  "N25930131": 1,
  "R185048": 1,
  "R6358272": 1,
  "R11677792": 1,
  "N25869410": 1,
  "R142282": 1,
  "R113141": 1,
  "N32675806": 1,
  "N5715309398": 1,
  "R270191": 1,
  "R404159": 1,
  "R117945": 1,
  "R346465": 1,
  "R9506158": 1,
  "R103703": 1,
  "R7964375": 1,
  "R40620": 1,
  "N21063119": 1,
  "R253824": 1,
  "N62270270": 1,
  "R12597837": 1,
  "R285864": 1,
  "R62559": 1,
  "R164609": 1,
  "R11797890": 1,
  "R197353": 1,
  "R206637": 1,
  "R18271830": 1,
  "R170120": 1,
  "R111737": 1,
  "R115274": 1,
  "R342792": 1,
  "R40730": 1,
  "R127167": 1,
  "R175549": 1,
  "R180348": 1,
  "R18019999": 1,
  "R4072985": 1,
  "N257838557": 1,
  "R5400893": 1,
  "R3909995": 1,
  "R197273": 1,
  "R3012945": 1,
  "R28722": 1,
  "R2888417": 1,
  "R176131": 1,
  "R170330": 1,
  "R3352040": 1,
  "R59195": 1,
  "R438171": 1,
  "R141008": 1,
  "R123292": 1,
  "R11675459": 1,
  "R6966465": 1,
  "R206980": 1,
  "N197698100": 1,
  "R296014": 1,
  "R112298": 1,
  "R111031": 1,
  "R62649": 1,
  "R51800": 1,
  "R102478": 1,
  "R2567380": 1,
  "R2866485": 1,
  "R340727": 1,
  "R117925": 1,
  "R62508": 1,
  "R2078292": 1,
  "N58957648": 1,
  "R8452792": 1,
  "R1155956": 1,
  "R59418": 1,
  "R3287346": 1,
  "R346956": 1,
  "R8896976": 1,
  "R41038": 1,
  "R62369": 1,
  "R4097196": 1,
  "R2833530": 1,
  "R171264": 1,
  "R169759": 1,
  "R6329645": 1,
  "N126244310": 1,
  "R34719": 1,
  "N59115290": 1,
  "R533154": 1,
  "R111147": 1,
  "N1667671370": 1,
  "R127864": 1,
  "R3464353": 1,
  "R6329316": 1,
  "N1738808199": 1,
  "R3227707": 1,
  "N261833893": 1,
  "R118879": 1,
  "R340783": 1,
  "N560229438": 1,
  "R44836": 1,
  "R8882104": 1,
  "R966358": 1,
  "R206672": 1,
  "R1430508": 1,
  "N27084072": 1,
  "R188218": 1,
  "R61423": 1,
  "R1250113": 1,
  "R254046": 1,
  "R6362934": 1,
  "R1682493": 1,
  "N29277817": 1,
  "R364087": 1,
  "R62768": 1,
  "N1242998122": 1,
  "R199071": 1,
  "R70279": 1,
  "R369472": 1,
  "R2396450": 1,
  "R119016": 1,
  "R114559": 1,
  "N291986732": 1,
  "R118894": 1,
  "R8348295": 1,
  "R345740": 1,
  "R340756": 1,
  "R6791758": 1,
  "R191230": 1,
  "R3529725": 1,
  "R42791": 1,
  "R11078268": 1,
  "R62564": 1,
  "R40642": 1,
  "R128653": 1,
  "R1675660": 1,
  "R5379538": 1,
  "R343535": 1,
  "R2456294": 1,
  "N315734346": 1,
  "R2259875": 1,
  "N4145201092": 1,
  "R2730349": 1,
  "R75628": 1,
  "R2833528": 1,
  "N29405229": 1,
  "R117981": 1,
  "R42659": 1,
  "R113919": 1,
  "R1681788": 1,
  "R10367676": 1,
  "R448590": 1,
  "N17328659": 1,
  "R59874": 1,
  "N1643504896": 1,
  "R3226004": 1,
  "R182954": 1,
  "N31376615": 1,
  "R174916": 1,
  "R170953": 1,
  "R149197": 1,
  "R40641": 1,
  "R176069": 1,
  "R135130": 1,
  "R3503615": 1,
  "R346204": 1,
  "R74687": 1,
  "R194000": 1,
  "R132206": 1,
  "R5961574": 1,
  "R39169": 1,
  "R36458": 1,
  "N9331795": 1,
  "R16132": 1,
  "R3221112": 1,
  "R62691": 1,
  "R5404101": 1,
  "N204648": 1,
  "R170584": 1,
  "R115286": 1,
  "R37774": 1,
  "R106956": 1,
  "R1829065": 1,
  "R182514": 1,
  "R114485": 1,
  "R1216778": 1,
  "N21674637": 1,
  "N2052329081": 1,
  "R11381689": 1,
  "N1842740533": 1,
  "R9092218": 1,
  "R4576938": 1,
  "R2799557": 1,
  "R113006": 1,
  "R905534": 1,
  "R184985": 1,
  "R112148": 1,
  "N303079568": 1,
  "R2689482": 1,
  "R2564500": 1,
  "R367666": 1,
  "R206670": 1,
  "R339887": 1,
  "R332321": 1,
  "R104492": 1,
  "R378685": 1,
  "N289534897": 1,
  "R1387968": 1,
  "R119009": 1,
  "W373067072": 1,
  "R3404205": 1,
  "R252208": 1,
  "R180261": 1,
  "R27027": 1,
  "R74090": 1,
  "R198930": 1,
  "R237599": 1,
  "R47534": 1,
  "R1752948": 1,
  "R62512": 1,
  "N175734291": 1,
  "R54517": 1,
  "R324269": 1,
  "R1343457": 1,
  "N428339450": 1,
  "R133571": 1,
  "R1567544": 1,
  "R2154556": 1,
  "R113870": 1,
  "R7034910": 1,
  "R42955": 1,
  "R7407678": 1,
  "R1769123": 1,
  "R195005": 1,
  "R117858": 1,
  "R40671": 1,
  "R42481": 1,
  "N5527648921": 1,
  "R198918": 1,
  "R2032280": 1,
  "R2009237": 1,
  "N25611736": 1,
  "N2613949295": 1,
  "N150921144": 1,
  "N8087537": 1,
  "R118870": 1,
  "N26559213": 1,
  "R2929054": 1,
  "R189924": 1,
  "R166717": 1,
  "R43452": 1,
  "N26396457": 1,
  "R186706": 1,
  "R109847": 1,
  "N567267943": 1,
  "R1674442": 1,
  "R2415335": 1,
  "R1649672": 1,
  "R376823": 1,
  "R11203697": 1,
  "R2110264": 1,
  "N1879089350": 1,
  "N27365302": 1,
  "R1891418": 1,
  "R8421413": 1,
  "R2465058": 1,
  "R238005": 1,
  "N289643197": 1,
  "R129568": 1,
  "R450381": 1,
  "R80348": 1,
  "R110842": 1,
  "R39384": 1,
  "N29098860": 1,
  "R1376330": 1,
  "N3233393892": 1,
  "R12200125": 1,
  "R3492156": 1,
  "R118856": 1,
  "R4085749": 1,
  "R2421460": 1,
  "timestamp": "1755987304"
};
